
<template>
<div>
<h1> Query the MetaflammDB metadata database using the MetaflammDB OWL ontology</h1>
<hr style='width: 100%'>
<h2> With a pre-defined queries: </h2>
   <div class="override-class" style="{ margin: '20px'}">
  <v-form ref="queryType">
         <v-select
          v-model="queryType"
          id="queryType"
          :items="items"
          item-text="queryType"
          item-value="abbr"
          label="Select"
          persistent-hint
          return-object
          single-line
        ></v-select>
        <v-btn @click="query" type="submit" color="success" form="queryType">Add plot</v-btn>
        <v-btn @click="unquery" type="submit" color="red" form="queryType">Remove plot</v-btn>
        </v-form>
        </div>
<br/>
<br/>

<template v-for="(child, index) in views">
 <!--<template v_if="views"> -->
 <!-- abc {{child['view-type']}}-->
 <!-- {{index}}-->

 <component :is="child['view-type']" :key="index" :title="child.view.title" :query_data="child.view.query_data" :date='child.view.date'/>

 <!--<component v-bind:is="MyComponent"> -->
 <!--</component>-->
 <!--<d-3-view> </d-3-view>-->
</template>

<br/>
<br/>
<hr style='width: 100%'>
<h2> With custom SPARQL queries using the OWL Metadata Ontology </h2>

<div contenteditable="true" spellcheck="false" v-highlight @keyup.down="submit">
  <pre class="language-javascript">
  <code>
    {{textArea}}
  </code>
</pre>
</div>

<h5> Please find more (pre-defined) custom SPARQL query examples in the documentation </h5>
<br/>
<div class="override-class" style="{ margin: '20px'}">
<v-btn @click="queryFreeText" type="submit" color="success">Query now</v-btn>
<v-btn @click="unqueryFreeText" type="submit" color="red">Clear results</v-btn>
</div>
<br/>
<h3 v-if="messageFromSPARQLQuery != ''"> Results: </h3>
<div style='display: table; margin-right: auto; margin-left: auto;' v-html='messageFromSPARQLQuery'></div>
<hr v-if="messageFromSPARQLQuery != ''" style='width: 100%'>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<hr style='width: 100%'>
<div v-if="doDebugging == true">
<h3> Debugging response from backend </h3>
<div class="response" v-html="message"/>
</div>
</div>
</template>

<script>
import QueryService from '@/services/QueryService'
import D3View from '@/components/D3View.vue'
import GraphView from '@/components/GraphView.vue'
import ExperimentsView from '@/components/ExperimentsView.vue'
import CohortView from '@/components/CohortView.vue'
import WordCloudView from '@/components/WordCloudView.vue'
import VueCodeHighlight from 'vue-code-highlight'
import 'prism-es6/components/prism-markup-templating'

import Vue from 'vue'
Vue.use(VueCodeHighlight)

export default {
  components: {
    D3View, GraphView, ExperimentsView, CohortView, WordCloudView
  },
  mounted () {
    this.queryType = 'Graph'
    this.query()
  },
  data () {
    return {
      message: null,
      queryType: 'Graph',
      doDebugging: true,
      textArea: `
        PREFIX meta: <http://www.semanticweb.org/stephangrein/ontologies/2022/3/metadata-ontology#>
        PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
        SELECT ?aname ?atitle ?adate ?atissue
          WHERE {
                ?general meta:createsExperiment ?experiment .
                ?general meta:Name ?aname .
                ?general meta:Title ?atitle .
                ?general meta:Date ?adate .
                ?experiment meta:Tissue ?atissue .
                FILTER (?atissue='adipose-tissue'^^xsd:string)
          }
      `,
      messageFromSPARQLQuery: '',
      views: [
      ],
      query_data: [], // JSON data from QueryService response
      items: [
        { abbr: 'Word Cloud', queryType: 'WordCloud' },
        { abbr: 'Cohorts information', queryType: 'Cohorts' },
        { abbr: 'Project dependencies', queryType: 'Graph' },
        { abbr: 'Experiments', queryType: 'Experiments' }
      ],
      select: { abbr: 'Project dependencies', queryType: 'Graph' }
    }
  },
  methods: {
    typing (el) {
      this.textArea = el.target.innerText
    },
    submit (el) {
      this.textArea = el.target.innerText
    },
    async query () {
      this.queryType = this.queryType.queryType
      const response = await QueryService.query({
        queryType: this.queryType,
        queryText: this.textArea
      }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources
      this.message = response.data.mydata
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      today = mm + '/' + dd + '/' + yyyy
      switch (this.queryType) {
        case 'Files':
          this.views.push({'view': {'title': 'I am a new card!'}, 'view-type': 'card2'})
          break
        case 'MyGDP':
          // eslint-disable-next-line
          this.views.push({'view': { 'query_data': Function("return " + response.data)(), 'title': 'Usage statistics', 'date': today}, 'view-type': 'D3View'})
          break
        case 'Graph':
          // eslint-disable-next-line
          this.views.push({'view': { 'query_data': response.data, 'title': 'Project dependencies', 'date': today}, 'view-type': 'GraphView'})
          break
        case 'Experiments':
          this.views.push({'view': { 'query_data': response.data }, 'view-type': 'ExperimentsView'})
          break
        case 'Cohorts':
          this.views.push({'view': { 'query_data': response.data }, 'view-type': 'CohortView'})
          break
        case 'WordCloud':
          this.views.push({'view': { 'query_data': response.data }, 'view-type': 'WordCloudView'})
          break
        default:
          break
      }
    },
    unquery () {
      this.views.pop()
    },
    async unqueryFreeText () {
      this.messageFromSPARQLQuery = ''
    },
    async queryFreeText () {
      // Note: Depending on the response (data type and data) from the SPARQL
      // query endpoint an appropriate visualization has to be provided in the
      // below method, for now only one data type (structure) is returned, so
      // it suffices to rely on the below method to construct frontend use-cases.
      const response = await QueryService.query({
        queryType: 'SPARQL',
        queryText: this.textArea
      }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources

      const array = response.data.mydata
      var myhtml = `
        <table>
        <tr>
        <th> Experimentator </th>
        <th> Title </th>
        <th> Tissue </th>
        </tr>
      `
      array.forEach(function (item, index) {
        myhtml = myhtml.concat(`<tr> <td> ${item.name} </td> <td> ${item.title} </td> <td> ${item.tissue} </td> </tr>`)
      })
      myhtml = myhtml.concat(`</table>`)
      this.messageFromSPARQLQuery = myhtml
      this.message = response.data.query
    }
  }
}
</script>

<style scoped>
.response {
  color:  green;
}
</style>
<style>
textarea {
  font-size: x-small;
  height: 150px;
  width: 530px;
  margin: 0px;
  padding: 0px;
}
h5 {
  padding: 0px;
  margin: 0px;
}
</style>

<style>
/**
 * okaidia theme for JavaScript, CSS and HTML
 * Loosely based on Monokai textmate theme by http://www.monokai.nl/
 * @author ocodia
 */

code[class*="language-"],
pre[class*="language-"] {
  color: #f8f8f2;
  background: none;
  text-shadow: 0 1px rgba(0, 0, 0, 0.3);
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

/* Code blocks */
pre[class*="language-"] {
  padding: 1em;
  margin: .5em 0;
  overflow: auto;
  border-radius: 0.3em;
}

:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: #272822;
}

/* Inline code */
:not(pre) > code[class*="language-"] {
  padding: .1em;
  border-radius: .3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #f8f8f2;
}

.namespace {
  opacity: .7;
}

.token.property,
.token.tag,
.token.constant,
.token.symbol,
.token.deleted {
  color: #f48990;
}

.token.boolean,
.token.number {
  color: #ae81ff;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #a6e22e;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string,
.token.variable {
  color: #f8f8f2;
}

.token.atrule,
.token.attr-value,
.token.function,
.token.class-name {
  color: #e6db74;
}

.token.keyword {
  color: #66d9ef;
}

.token.regex,
.token.important {
  color: #fd971f;
}

.token.important,
.token.bold {
  font-weight: bold;
}
.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

div pre[class*="language-"] {
  display: inline-block;
  width: 100%;
  padding-right: 10em;
  padding-top: 3rem;
  border-radius: 6px;
  background-image: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="54" height="14" viewBox="0 0 54 14"><g fill="none" fillRule="evenodd" transform="translate(1 1)"><circle cx="6" cy="6" r="6" fill="%23FF5F56" stroke="%23E0443E" strokeWidth=".5" /><circle cx="26" cy="6" r="6" fill="%23FFBD2E" stroke="%23DEA123" strokeWidth=".5" /><circle cx="46" cy="6" r="6" fill="%2327C93F" stroke="%231AAB29" strokeWidth=".5" /></g></svg>');
  background-repeat: no-repeat;
  background-position: 16px 16px;
  box-shadow: 5px 5px 15px 0px rgba(50, 50, 50, 0.75);
}
.override-class .v-input {
  display: inline-block;
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/views/QueryComponent.vue